// Timezone formatting helper.
// Ensures consistent time display across the application using user preferences.

import { type UserProfile } from './profile';

export const DEFAULT_TIMEZONE = 'Australia/Adelaide';

/**
 * Returns a closure for formatting dates based on a profile's timezone.
 */
export function createDateFormatter(
  profile: UserProfile | null | undefined,
  options: Intl.DateTimeFormatOptions,
  locale = 'en-AU'
) {
  const timeZone = profile?.timezone || DEFAULT_TIMEZONE;
  
  return new Intl.DateTimeFormat(locale, {
    ...options,
    timeZone,
  });
}

/**
 * Directly formats a date using the provided profile's timezone.
 */
export function formatInUserTime(
  date: Date,
  profile: UserProfile | null | undefined,
  options: Intl.DateTimeFormatOptions,
  locale = 'en-AU'
): string {
  const df = createDateFormatter(profile, options, locale);
  return df.format(date);
}
